import type { FaireProductEntity } from "../../entity_types/product";

export const p_8jadyyfzkq: FaireProductEntity = {
  token: "p_8jadyyfzkq",
  type: "product",
  name: "Juniper Short Tumbler / Dof Glass / Set of 2",
  brandToken: "b_dtfc7uc37e",
  brandName: "Aaron Probyn US",
  imageUrl:
    "https://cdn.faire.com/fastly/3036822eeb048eb45bf0b8ded9565c2e6a69d1d70fe1b598e6d50e3e60bf4081.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b12c7ab318b6cddd88bbd0d3e467700eed10fc57a4bd5cd84a9c38d12a4e6386.jpeg",
    "https://cdn.faire.com/fastly/1a51942364731e7828af56aa7f575813efe7144d4d0914601a2fd6f579ca355c.jpeg",
  ],
  priceDollars: 17.5,
  description:
    "Juniper is a sculptural glassware range designed to elevate the drinking experience by enhancing both flavor and aroma. The glasses are graphic in form yet functional and satisfying to use, and their striking geometric silhouette adds interest to any table, bar, or drinks trolley.\n\nJuniper short tumbler / DOF Glass.\nSize: Ø 9cm x H 7.5cm.\n\nPacked as a set of 2.\nColor: clear",
  tags: [],
  msrpDollars: 35,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-04T23:53:28.539Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
